import React from "react";
import { Info, X } from "lucide-react";

function AboutPopup({ closePopup, confirm }) {
    // Import logo relative to this file's location (src/view/header/ -> src/logo.svg)
    // const logoSrc = require('../../logo.svg').default;

    return (
        <div className="oct_about-modal-v2">
            <div className="oct_about-dialog-v2">
                <div className="oct_about-header-v2">
                    <div className="oct_about-header-glow-v2" />

                    <div className="oct_about-title-group-v2">
                        <div className="oct_about-title-icon-v2">
                            <Info size={20} />
                        </div>

                        <h4 className="oct_about-title-v2">About</h4>
                    </div>

                    <button
                        type="button"
                        className="oct_about-close-v2"
                        onClick={() => closePopup()}
                        aria-label="Close about popup"
                    >
                        <X size={16} />
                    </button>
                </div>
                <div className="oct_about-body-v2">
                    <div className="logo-container">
                        <img src={`${process.env.PUBLIC_URL}/octopus-logo.svg`} alt="Octopus Cybersecurity" />
                    </div>

                    <div className="info-section">
                        <p>
                            <span className="label">Version:</span> 3.2
                        </p>
                        <p>
                            <span className="label">Date:</span> July 15, 2026
                        </p>
                    </div>

                    <div className="footer-section">
                        <p>
                            Copyright © 2026 Octopus Cybersecurity inc. All rights reserved.
                        </p>
                        <p>
                            <a
                                href="https://www.octopus-var.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                https://www.octopus-var.com/
                            </a>
                        </p>
                        <p>
                            To send comments and report bugs use the following email:
                            <br />
                            <a href="mailto:info@octopus-var.com">
                                info@octopus-var.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default AboutPopup;
